var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "daily-agent-activity-chart-main px-2" }, [
    _c("div", { staticClass: "header" }, [
      _c("span", [_vm._v(_vm._s(_vm.$t("report.agentActivity")))]),
      _vm._v(" "),
      _c(
        "span",
        { staticClass: "sDate" },
        [
          _c("a-button", {
            attrs: { type: "dashed", shape: "circle", icon: "left" },
            on: { click: _vm.goPreviousDay },
          }),
          _vm._v(
            "\n            " +
              _vm._s(_vm.getStartDateHumanize()) +
              "\n            "
          ),
          _c("a-button", {
            attrs: {
              type: "dashed",
              shape: "circle",
              icon: "right",
              disabled: _vm.nextDayAvailable(),
            },
            on: { click: _vm.goNextDay },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("span"),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "toolbar px-1" }, [
      _c("div", { staticClass: "toolbar-settings" }, [
        _c(
          "div",
          { staticClass: "toolbar-item" },
          [
            _c("label", { staticClass: "text-uppercase pt-2 w-100" }, [
              _vm._v(_vm._s(_vm.$t("message.hideInactiveAgents"))),
            ]),
            _vm._v(" "),
            _c("md-switch", {
              staticClass: "md-primary ml-3",
              model: {
                value: _vm.hideInactiveAgents,
                callback: function ($$v) {
                  _vm.hideInactiveAgents = $$v
                },
                expression: "hideInactiveAgents",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "toolbar-item" },
          [
            _c("label", { staticClass: "text-uppercase pt-2 w-100" }, [
              _vm._v(_vm._s(_vm.$t("message.hideMinorValues"))),
            ]),
            _vm._v(" "),
            _c("md-switch", {
              staticClass: "md-primary ml-3",
              model: {
                value: _vm.hideMinorValues,
                callback: function ($$v) {
                  _vm.hideMinorValues = $$v
                },
                expression: "hideMinorValues",
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _vm._m(0),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { key: Math.random() * 100, staticClass: "chart-rows" },
      [
        _vm.loading
          ? _c("a-skeleton", { attrs: { avatar: "", paragraph: { rows: 1 } } })
          : _vm._e(),
        _vm._v(" "),
        _vm.loading
          ? _c("a-skeleton", { attrs: { avatar: "", paragraph: { rows: 1 } } })
          : _vm._e(),
        _vm._v(" "),
        _vm.loading
          ? _c("a-skeleton", { attrs: { avatar: "", paragraph: { rows: 1 } } })
          : _vm._e(),
        _vm._v(" "),
        _vm.loading
          ? _c("a-skeleton", { attrs: { avatar: "", paragraph: { rows: 1 } } })
          : _vm._e(),
        _vm._v(" "),
        _vm.loading
          ? _c("a-skeleton", { attrs: { avatar: "", paragraph: { rows: 1 } } })
          : _vm._e(),
        _vm._v(" "),
        _vm._l(_vm.getFilteredItems(), function (item) {
          return !_vm.loading
            ? _c("div", { key: Math.random(), staticClass: "chart-row" }, [
                _c(
                  "div",
                  { staticClass: "agent-info" },
                  [
                    _c(
                      "a-avatar",
                      {
                        staticStyle: {
                          "background-color": "rgb(255 255 255) !important",
                          color: "#368dda",
                          "font-size": "25px",
                          margin: "initial",
                        },
                        attrs: {
                          size: 50,
                          src: item.agent.gravatar ? item.agent.gravatar : null,
                          username: item.agent.gravatar
                            ? null
                            : item.agent.name,
                        },
                      },
                      [
                        _vm._v(
                          _vm._s(
                            item.agent.gravatar
                              ? null
                              : item.agent.name.substr(0, 1).toUpperCase()
                          ) + "\n                "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "d-flex flex-column justify-content-center align-items-center pl-2",
                      },
                      [
                        _c("span", [_vm._v(_vm._s(item.agent.name))]),
                        _vm._v(" "),
                        _c("span", [_vm._v(_vm._s(item.agent.email))]),
                      ]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "agent-bar" },
                  [
                    _c("AgentActivityBar", {
                      attrs: {
                        activities: item.actions,
                        "last-activity": item.lastAction,
                        "start-day": _vm.startDate,
                        "hide-inactive": _vm.hideInactiveAgents,
                        "hide-minor-values": _vm.hideMinorValues,
                      },
                    }),
                  ],
                  1
                ),
              ])
            : _vm._e()
        }),
        _vm._v(" "),
        !_vm.loading && !_vm.items.length
          ? _c("div", [_c("a-list", { attrs: { "data-source": [] } })], 1)
          : _vm._e(),
      ],
      2
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "toolbar-tick" }, [
      _c("span", [_vm._v("12 AM")]),
      _vm._v(" "),
      _c("span", [_vm._v("4 AM")]),
      _vm._v(" "),
      _c("span", [_vm._v("8 AM")]),
      _vm._v(" "),
      _c("span", [_vm._v("12 PM")]),
      _vm._v(" "),
      _c("span", [_vm._v("4 PM")]),
      _vm._v(" "),
      _c("span", [_vm._v("8 PM")]),
      _vm._v(" "),
      _c("span", [_vm._v("12 AM")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }